import React from "react";
import "../../../ReactKaamvalaWebsite/Pages/FQA/FQA.css";
import property from "../../../ReactKaamvalaWebsite/assets/icon/property.svg";
import call from "../../../ReactKaamvalaWebsite/assets/icon/call.svg";
import awardframe from "../../../ReactKaamvalaWebsite/assets/icon/awardframe.svg";
import search from "../../../ReactKaamvalaWebsite/assets/icon/search.svg";
const FQA = () => {
  return (
    <>
      <div id="FQA">
        <section className="FQA">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-heading">
                <h5>How can we help you?</h5>
                <form action="" id="input-fields" className="search">
                  <input type="search" placeholder="Search..." />
                  <button type="submit">
                    <img src={search} alt="" />
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="container py-5">
            <div className="form-card">
              <div className="row">
                <div className="col-md-12 need">
                  <p>Need help ? Contact us.</p>
                </div>
                <div className="col-md-12 d-flex  headings">
                  {/* <h5
                    style={{
                      fontSize: "18px",
                    }}
                  >
                    <span>Call:</span>
                    *** **** *128
                  </h5> */}
                  <h5>
                    <span>Email:</span>
                    info@kaamvala.com
                  </h5>
                  <h5>
                    <span>Timing:</span>
                    9AM-9PM,Monday to Friday
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="common">
          <div className="container py-5">
            <div className="col-md-12">
              <div className="contact-us-title text-center justify-content-center m-auto py-2">
                <h4>Common Help Categories</h4>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 col-lg-12">
                <div className="row">
                  <div className="col-md-4 justify-content-center servillance-2 d-flex">
                    <div className="servillance_award_section">
                      <div className=" servillance_award d-flex justify-content-center mx-auto">
                        <img
                          src={awardframe}
                          className="d-flex image-fluid"
                          width="80"
                          height="80"
                          alt="web and app development"
                        />
                      </div>
                      <div className="servillance_award_text text-center mt-3">
                        <h3>Over 1 Crore</h3>
                        <p>Highly Qualified Candidates</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 justify-content-center servillance-2 d-flex">
                    <div className="servillance_award_section">
                      <div className="servillance_award d-flex justify-content-center mx-auto">
                        <img
                          src={call}
                          className="d-flex image-fluid"
                          width="80"
                          height="80"
                          alt="web and app development"
                        />
                      </div>
                      <div className="servillance_award_text text-center mt-3">
                        <h3>3 Lakh+</h3>
                        <p>Interviews Every Month</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 justify-content-center servillance-2 d-flex">
                    <div className="servillance_award_section">
                      <div className="servillance_award d-flex justify-content-center mx-auto">
                        <img
                          src={property}
                          className="d-flex image-fluid"
                          width="80"
                          height="80"
                          alt="web and app development"
                        />
                      </div>
                      <div className="servillance_award_text text-center mt-3">
                        <h3>650+</h3>
                        <p>Cities Across India</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="accordion">
          <div className="container my-5">
            <div className="row">
              <div className="col-md-12">
                <div className="accordion faq_accordion" id="accordionExample">
                  <div className="accordion-item faq_accordion_item">
                    <h3 className="accordion-header">
                      <button
                        className="accordion-button faq_accordion_button faq_heading collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="false"
                        aria-controls="collapseOne"
                      >
                        How do I set up an employer account on kaamvala?
                      </button>
                    </h3>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        To create an account on Kaamvala, simply sign up with
                        your details and verify your phone number using an OTP.
                        After that, you can start posting jobs right away.
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item faq_accordion_item">
                    <h3 className="accordion-header">
                      <button
                        className="accordion-button faq_accordion_button faq_heading collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseOne"
                      >
                        How do I begin hiring with Kaamvala?
                      </button>
                    </h3>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        You can start hiring in three easy steps:
                      </div>
                      <ul>
                        <li className="list-disc ml-5">
                          <b>Post a Job:</b>
                          Register and post your job in under 5 minutes using
                          OTP for verification.
                        </li>
                        <li className="list-disc ml-5">
                          <b>Select a Hiring Plan: </b>
                          Select the hiring plan and proceed to payment.
                        </li>
                        <li className="list-disc ml-5">
                          Get Verified: "Our team will contact you for your
                          account verification."
                        </li>
                        <li className="list-disc ml-5">
                          <b>Accept Applications: </b>
                          Candidates will start approaching you after the
                          process of verification.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="accordion-item faq_accordion_item">
                    <h3 className="accordion-header">
                      <button
                        className="accordion-button faq_accordion_button faq_heading collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        How does Kaamvala help me find the most suitable
                        candidates quickly ?
                      </button>
                    </h3>
                    <div
                      id="collapseThree"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Kaamvala uses smart filters to make sure only candidates
                        who meet your job requirements can see and apply to your
                        job. This saves your time and ensures you get qualified
                        applicants.
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item faq_accordion_item">
                    <h3 className="accordion-header">
                      <button
                        className="accordion-button faq_accordion_button faq_heading collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFour"
                        aria-expanded="false"
                        aria-controls="collapseFour"
                      >
                        Can I edit or update my job post after it has been
                        published?
                      </button>
                    </h3>
                    <div
                      id="collapseFour"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Yes, you can easily edit or update your job post at any
                        time through your employer dashboard.
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item faq_accordion_item">
                    <h3 className="accordion-header">
                      <button
                        className="accordion-button faq_accordion_button faq_heading collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFive"
                        aria-expanded="false"
                        aria-controls="collapseFive"
                      >
                        What payment options are available on Kaamvala?
                      </button>
                    </h3>
                    <div
                      id="collapseFive"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Kaamvala accepts multiple payment methods including:
                      </div>
                      <ul className="faq-text faq-list">
                        <li className="list-disc ml-5">credit Card</li>
                        <li className="list-disc ml-5">Debit Card</li>
                        <li className="list-disc ml-5">Net Banking</li>
                        <li className="list-disc ml-5">UPI</li>
                        <li>Digital Wallets</li>
                      </ul>
                    </div>
                  </div>
                  <div className="accordion-item faq_accordion_item">
                    <h3 className="accordion-header">
                      <button
                        className="accordion-button faq_accordion_button faq_heading collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSix"
                        aria-expanded="false"
                        aria-controls="collapseSix"
                      >
                        Can I get a GST invoice after making a purchase on
                        Kaamvala?
                      </button>
                    </h3>
                    <div
                      id="collapseSix"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Yes, Kaamvala provides a GST invoice after you purchase
                        a hiring plan. The invoice is sent to your email and can
                        be used to claim input tax credit. Make sure your GST
                        number is correct in your profile.
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item faq_accordion_item">
                    <h3 className="accordion-header">
                      <button
                        className="accordion-button faq_accordion_button faq_heading collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSeven"
                        aria-expanded="false"
                        aria-controls="collapseSeven"
                      >
                        Is it possible to get a refund for my Kaamvala plan?
                      </button>
                    </h3>
                    <div
                      id="collapseSeven"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        If we fail to meet your hiring needs, you may be
                        eligible for a refund based on our policy. Refunds are
                        not available for job posts from placement agencies or
                        consultancies.
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item faq_accordion_item">
                    <h3 className="accordion-header">
                      <button
                        className="accordion-button faq_accordion_button faq_heading collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseEight"
                        aria-expanded="false"
                        aria-controls="collapseEight"
                      >
                        Does Kaamvala offer special rates for bulk hiring?
                      </button>
                    </h3>
                    <div
                      id="collapseEight"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Yes, Kaamvala provides bulk hiring discounts if you need
                        to recruit more than ten employees at once. Please
                        contact our sales team for details.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
export default FQA;
